(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("jquery"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "jquery", "moment"], factory);
	else if(typeof exports === 'object')
		exports["handsfreeForWebsiteModules"] = factory(require("lodash"), require("jquery"), require("moment"));
	else
		root["handsfreeForWebsiteModules"] = factory(root["lodash"], root["jquery"], root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 